import React, { useEffect, useState } from 'react';
import ReactJoyride from 'react-joyride';
import { useSelector } from 'react-redux';

import TooltipComponent, { steps } from './TooltipComponent';

const Joyride = () => {
	const [stepIndex, setStepIndex] = useState(0);
	const { CDTourStepIndex, CDTourRun } = useSelector((state) => state.tourReducer);

	useEffect(() => setTimeout(() => setStepIndex(CDTourStepIndex), 100), [CDTourStepIndex]);

	return (
		<ReactJoyride
			steps={steps}
			run={CDTourRun}
			disableScrolling
			disableCloseOnEsc
			disableOverlayClose
			stepIndex={stepIndex}
			tooltipComponent={TooltipComponent}
		/>
	);
};

export default Joyride;
